<template>
    <div :class="$attrs.class">
        <label :for="id" class="form-label">{{label}}</label>
        <input :id="id" v-bind="{ ...$attrs, class: null }" class="form-input" :class="{ error: error }" :type="type"  :value="modelValue" @input="updateModelValue" placeholder="H:i">
        <div v-if="error" class="form-error">{{ error }}</div>
        <div v-else-if="custError" class="mt-2 text-red-500 h-8">{{ custError }}</div>
    </div>
</template>

<script>

export default{
    inheritAttrs: false,
    props: {
        id: String,
        error: String,
        custError: String,
        type: {
            type: String,
            default: 'text'
        },
        label: String,
        modelValue: String
    },
    emits: ['update:modelValue'],
    mounted: function(){
        const self = this;
        $("#"+this.id).datetimepicker({
            datepicker: false,
            format:'H:i',
            lang: 'id',
            onChangeDateTime:function(dp,$input){
                self.$emit('update:modelValue',$input.val());
            }
        })
    },
    methods:{
        
    }
}

</script>